import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/about/img2.jpg';
import Carrossel from './Carrossel';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home2() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/servicos'); // Redireciona para a página /services
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <S.borderCard>
            <S.divP>
              <h1>NOSSA HISTÓRIA</h1>
              <p>
                O Travessias nasceu da necessidade de uma formação mais ampla e
                inclusiva. Com trajetórias diversas, nos encontramos na UFMG,
                onde nos graduamos em psicologia e nos especializamos em
                psicanálise. Reconhecemos que a carreira clínica pode ser
                solitária e desafiadora, especialmente no início, e que as
                formações em psicanálise muitas vezes se restringem a poucos
                autores.
              </p>
              <p>
                Para superar essas dificuldades, nos organizamos como grupo,
                promovendo encontros entre psicanalistas e pessoas em busca de
                tratamento, e oferecendo uma formação contínua e plural.
                Acreditamos que a formação de um analista é uma travessia
                pessoal, enriquecida por diversos encontros teóricos, técnicos e
                afetivos.
              </p>
              <p>
                Travessias – Percursos em Psicanálise reflete nosso compromisso
                com uma formação diversa e inclusiva. Cada analista traça seu
                caminho único, a partir de múltiplos encontros e aprendizagens
                que moldam suas trajetórias.
              </p>
              <button onClick={handleNavigation}>
                Descubra nossos serviços
              </button>
            </S.divP>
            {/* <img src={bordercardimg} /> */}
            <hr />
          </S.borderCard>
          <Carrossel />
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
